// YELLOW

import React, { useState } from "react";
import CustomModal from "components/Modal/CustomModal";
import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import { notify, ToastType } from "utils/Toast";
import { ValidationErrorMessages } from "utils/Error";

interface Props {
  TableContent: any;
  HeaderMinWidth?: Array<any>;
  changeData: () => void;
}

const RentalRequest: React.FC<Props> = ({
  TableContent,
  HeaderMinWidth,
  changeData,
}) => {
  const [showModalRequest, setShowModalRequest] = useState<boolean>(false);
  const [showModalRequestDelete, setShowModalRequestDelete] =
    useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | undefined>();
  const [selectedObj, setSelectedObj] = useState<any>();

  const showRequest = (id: number) => {
    setShowModalRequest(true);
    setSelectedId(id);
    setSelectedObj(TableContent.find((item: any) => item.demandId === id));
  };

  const deleteRequestVerify = (id: number) => {
    setShowModalRequestDelete(true);
    setSelectedId(id);
  };

  const deleteRentalFunc = (id: number | undefined) => {
    if (typeof id === undefined) {
      notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
    } else {
      Axios(
        AxiosMethodEnum.post,
        Axios_Route.RENTAL_DELETE + `?demandId=${id}`
      ).then(({ response, success }) => {
        if (success) {
          changeData();
          setShowModalRequestDelete(false);
          setSelectedId(undefined);
          notify(
            ValidationErrorMessages.SUCCESS.REQUEST_DELETED_SUCCESSFULLY,
            ToastType.success
          );
        } else {
          notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
        }
      });
    }
  };

  return (
    <>
      {TableContent.map((item: any, key: any) => (
        <div
          key={key}
          style={{
            borderBottom:
              key === TableContent.length - 1 ? "none" : "1px solid #f6f6f6",
          }}
          className="table-content"
        >
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[0] : "",
            }}
          >
            {item.demandId}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[1] : "",
            }}
          >
            {item.date}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[2] : "",
            }}
          >
            {item.fullName}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[3] : "",
            }}
          >
            {item.propertyType}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[4] : "",
            }}
          >
            {item.propertySize}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[5] : "",
            }}
          >
            {item.priceRange}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[6] : "",
            }}
          >
            <span
              onClick={() => showRequest(item.demandId)}
              className="show-data-btn"
            >
              Show Request
            </span>
            <span
              onClick={() => deleteRequestVerify(item.demandId)}
              className="delete-btn"
            >
              Delete
            </span>
          </p>
        </div>
      ))}
      <CustomModal
        showModal={showModalRequest}
        close={() => setShowModalRequest(false)}
        closeAble={true}
        maxWidth={"90%"}
      >
        <div>
          {selectedObj !== undefined ? (
            <>
              <p
                style={{
                  borderBottom: "solid 1px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Request{" "}
                <span style={{ fontWeight: "400", fontSize: "12px" }}>
                  code : {selectedObj.demandId}
                </span>
              </p>

              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Date:</span>{" "}
                {selectedObj.date}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Full Name:</span>{" "}
                {selectedObj.fullName}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Email Address:</span>{" "}
                {selectedObj.emailAddress}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Phone:</span>{" "}
                {selectedObj.phone}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Property Type:</span>{" "}
                {selectedObj.propertyType}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Property Size:</span>{" "}
                {selectedObj.propertySize}
              </p>
              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <span style={{ fontWeight: "600" }}>Price Range:</span>{" "}
                {selectedObj.priceRange}
              </p>
            </>
          ) : (
            <></>
          )}
        </div>
      </CustomModal>
      <CustomModal
        showModal={showModalRequestDelete}
        close={() => setShowModalRequestDelete(false)}
        closeAble={true}
        maxWidth={"90%"}
      >
        <div>
          <p
            style={{
              borderBottom: "solid 1px",
              fontWeight: "600",
              marginBottom: "20px",
            }}
          >
            Delete
          </p>
          <p style={{ fontSize: "14px" }}>
            Are your sure you want to delete this request?
          </p>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            Request code:{" "}
            <span style={{ fontWeight: "800" }}>{selectedId}</span>
          </p>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              marginTop: "30px",
            }}
          >
            <span
              onClick={() => deleteRentalFunc(selectedId)}
              className="delete-btn verify-delete"
            >
              Delete Request
            </span>
            <span
              onClick={() => setShowModalRequestDelete(false)}
              className="cancel-btn"
            >
              Cancel
            </span>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default RentalRequest;
